export const isPermitted = currentUser => {
    return !!currentUser?.attributes?.profile?.publicData?.permitted
}